import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { HERO_IMAGE } from "./data/content";
type MetaPixelFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
    requestIdleCallback?: (callback: () => void, options?: {
      timeout: number;
    }) => number;
  }
}
const FONTS_HREF = "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Cormorant+Garamond:ital,wght@0,600;1,600&display=swap";
const SEO = {
  title: "Megapack Bolsos Crochet Pro | 6 tomos + 5 bonos",
  description: "Creá tu colección de bolsos de crochet para este verano. 6 tomos completos + 5 bonos exclusivos para aprender, crear y empezar a vender bolsos modernos paso a paso."
};
function upsertMeta(attribute: "name" | "property", key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.content = content;
}

/** Language, title, description and social sharing tags. */
function applyDocumentMeta() {
  document.documentElement.lang = "es";
  document.title = SEO.title;
  upsertMeta("name", "description", SEO.description);
  upsertMeta("name", "theme-color", "#FAF6F0");
  upsertMeta("property", "og:type", "website");
  upsertMeta("property", "og:title", SEO.title);
  upsertMeta("property", "og:description", SEO.description);
  upsertMeta("property", "og:image", HERO_IMAGE);
  upsertMeta("property", "og:locale", "es_AR");
  upsertMeta("name", "twitter:card", "summary_large_image");
  upsertMeta("name", "twitter:title", SEO.title);
  upsertMeta("name", "twitter:description", SEO.description);
  upsertMeta("name", "twitter:image", HERO_IMAGE);
}
function addPreconnect(href: string, crossOrigin = false) {
  const link = document.createElement("link");
  link.rel = "preconnect";
  link.href = href;
  if (crossOrigin) link.crossOrigin = "anonymous";
  document.head.appendChild(link);
}

/** Warms up the image that drives the Largest Contentful Paint. */
function preloadHeroImage() {
  const preload = document.createElement("link");
  preload.rel = "preload";
  preload.as = "image";
  preload.href = HERO_IMAGE;
  preload.setAttribute("fetchpriority", "high");
  document.head.appendChild(preload);
}

/** Loads the web fonts without blocking the first paint (system fallback shows instantly). */
function loadFonts() {
  addPreconnect("https://fonts.googleapis.com");
  addPreconnect("https://fonts.gstatic.com", true);
  const stylesheet = document.createElement("link");
  stylesheet.rel = "stylesheet";
  stylesheet.href = FONTS_HREF;
  stylesheet.media = "print";
  stylesheet.addEventListener("load", () => {
    stylesheet.media = "all";
  });
  document.head.appendChild(stylesheet);
}
function initializeMetaPixel() {
  if (window.fbq) return;
  const fbq: MetaPixelFunction = (...args) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
      return;
    }
    fbq.queue?.push(args);
  };
  fbq.queue = [];
  fbq.push = (...args) => fbq.queue?.push(args);
  fbq.loaded = true;
  fbq.version = "2.0";
  window.fbq = fbq;
  window._fbq = fbq;
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
  fbq("init", "938900698828130");
  fbq("track", "PageView");
}

/** Tracking runs after the page is interactive so it never competes with the first render. */
function scheduleMetaPixel() {
  const start = () => {
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(initializeMetaPixel, {
        timeout: 2500
      });
      return;
    }
    window.setTimeout(initializeMetaPixel, 1200);
  };
  if (document.readyState === "complete") {
    start();
    return;
  }
  window.addEventListener("load", start, {
    once: true
  });
}
preloadHeroImage();
loadFonts();
applyDocumentMeta();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-325" data-mp="3uexonyy8x1u2" />);
}
scheduleMetaPixel();